import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-select",
  "use": "icon-select-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-select\"><defs><style type=\"text/css\"></style></defs><path d=\"M390.82315 992.148571 3.623527 629.771287 108.509343 517.700839 368.604102 761.120824 898.508891 29.349445 1022.830361 119.375831Z\" p-id=\"2398\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol